import { gigBizApi } from './gigBizApi'

export const apiClient = {
  gigBizApi: gigBizApi.apis,
}
